var React = require('react');

function IconCloseCircleInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 24a12 12 0 1112-12 12 12 0 01-12 12zm0-22.51A10.51 10.51 0 1022.51 12 10.52 10.52 0 0012 1.49z","key":0}),React.createElement("path",{"d":"M15.98 17.03l-3.94-3.94-3.94 3.94-1.06-1.05 3.94-3.94L7.04 8.1 8.1 7.04l3.94 3.94 3.94-3.94 1.05 1.06-3.94 3.94 3.94 3.94-1.05 1.05z","key":1})]);
}

IconCloseCircleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconCloseCircleInline;

IconCloseCircleInline.default = IconCloseCircleInline;
